import { HeroColorsV4, HeroColorsV5 } from './types';

export const breakpoints = {
  mobile: 375,
  tablet: 768,
};

export const backgroundColorMap: {
  [key in HeroColorsV4 | HeroColorsV5]: HeroColorsV5;
} = {
  ocean40: 'night',
  sun60: 'moss',
  lava60: 'zapier',
  white: 'neutral100',
  neutral100: 'neutral100',
  zapier: 'zapier',
  night: 'night',
  moss: 'moss',
  neutral800: 'neutral800',
};
